<template>
  <v-row align="center" dense>
    <v-col cols="auto">
      <tcn-file-icon width="30" :file-name="file.name" left/>
    </v-col>
    <v-col cols="auto"
           style="display: inline-flex; align-items: center;"
           class="user-details">
            <span
                class="font-weight-bold"
            >{{ file.name }}</span
            >
    </v-col>
  </v-row>
</template>

<script>
import TcnFileIcon from "../../TecnaFileIcon/TcnFileIcon.vue";

export default {
  name: "FileSuggestion",
  props: ['file'],
  components: {TcnFileIcon},
}
</script>

<style scoped>

</style>
